module.exports = __webpack_public_path__ + "static/media/banner_mas_informados_mobile.adee36e6.png";